import React from 'react'

function NotFound() {
    return (
        <div>Error404</div>
    )
}

export default NotFound